
export const mixin = {
  data: function () {
    return {
      isLike:false,
      likeNum:0,
      likeUsers: null,
      readNum:0,
      readUserList:null,
    };
  },
  props: {
    businessKey: {
      type: String,
      default: function () {
        return ''
      }
    },
    formInfoId: {
      type: String,
      default: function () {
        return ''
      }
    }
  },
  computed:{

  },
  created () {

  },
  mounted () {
    this.isLike = false;
    this.likeNum = 0;
    this.readNum = 0;
    this.likeUsers = null;
    this.readUserList = null;
    console.log(this.businessKey,'-------',this.formInfoId);
    // 获取点赞人列表，已阅数量，当前任是否点赞
    this.loadData();
  },
  methods: {
    like(){
      this.util.mask('  ');
      this.util.restPost('/api_v1/form/read_like/like',{businessKey:this.businessKey,formInfoId:this.formInfoId,like:!this.isLike},(res)=>{
        if(res && res.status == 200 ){
          // 重新刷新页面
          this.isLike = !this.isLike;
         this.loadData();
         this.util.unmask();
        }
      },()=>{
        this.util.unmask();
      });
    },
    loadData(){
      this.util.restGet('/api_v1/form/read_like/data',{businessKey:this.businessKey,formInfoId:this.formInfoId},(res)=>{
        if(res && res.status == 200 && res.data){
          this.isLike = res.data.like ;
          this.likeNum = res.data.likeNum;
          this.readNum = res.data.readNum;
          this.likeUsers = res.data.likeUsers;
        }
      });
    },
    showReadList(){
      this.util.restGet('/api_v1/form/read_like/read',{businessKey:this.businessKey,formInfoId:this.formInfoId},(res)=>{
       if(res && res.status == 200 && res.data){

          this.readUserList = res.data;
        }
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/common/form/read-like/index.js